/*
 * @Author: lihy lihy@zhiannet.com
 * @Date: 2024-07-15 19:22:42
 * @LastEditors: lihy lihy@zhiannet.com
 * @LastEditTime: 2025-06-23 13:00:58
 * @FilePath: /nstk/src/src/router/modules/home.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
const { VITE_HIDE_HOME } = import.meta.env
const Layout = () => import("@/layout/index.vue")

export default {
  path: "/",
  name: "Home",
  component: Layout,
  redirect: "/workbench/dashboard",
  meta: {
    icon: "ep:home-filled",
    title: "工作台",
    rank: 0
  },
  children: [
    // 完全动态路由，所有业务路由都由权限系统管理
    // 如果没有权限或路由，会显示 403 或空白页面
  ]
} satisfies RouteConfigsTable
